/* eslint-disable tree-shaking/no-side-effects-in-initialization */
import gql from 'graphql-tag'

const USER_EXPERIMENTS = /*#__PURE__*/ gql`
  query {
    getUserExperiments {
      userUuid
      experimentId
      variationId
    }
  }
`

export {USER_EXPERIMENTS}
